export default "__VITE_ASSET__DvfgtRbn__"